import type { ReactNode } from 'react'
import { GlobalDateProvider } from './GlobalDateProvider'
import { TenantProvider } from './TenantContext'
import { StructureProvider } from './StructureProvider'

/**
 * Combines GlobalDateProvider + TenantProvider + StructureProvider into a single wrapper.
 * Eliminates provider nesting boilerplate in routes that require all contexts.
 *
 * Prefer this over manually nesting:
 * ❌ <GlobalDateProvider><TenantProvider><StructureProvider>{children}</StructureProvider></TenantProvider></GlobalDateProvider>
 * ✅ <AppProviders>{children}</AppProviders>
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <GlobalDateProvider>
      <TenantProvider>
        <StructureProvider>
          {children}
        </StructureProvider>
      </TenantProvider>
    </GlobalDateProvider>
  )
}
